import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by component like
 * PopularDestination
 */

/**
 * This method return a Request object after delete unnecesary paramter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformRequestPopularDestination = (request) => {
  // params to delete don't matter the value store
  const paramsDelete = [
    'uiDatesYearsAdjustmentPatch',
    'siteEdition',
    'airlineIataCode',
    'page',
    'airport',
  ];

  // params to delete when has empty value
  const paramsEmpty = [
    'origins',
    'destinations',
    'outputCurrencies',
    'markets',
    'currencyPricingSettings',
    'travelClasses',
  ];

  const cleanRequest = transformRequest(request, paramsDelete, paramsEmpty);

  // clean request is the final object after all cleaning operation
  return cleanRequest;
};

export default transformRequestPopularDestination;
